import React, { useState, useRef, useEffect } from 'react';
import styles from './Guide.module.css';

import gal1 from '../../images/בית פרטי בשחור ולבן 1.webp';
import gal2 from '../../images/יוקרה במגדל - דירת יוקרה אורבנית 1.webp';
import gal3 from '../../images/חלום טוסקני - דופלקס כפרי 1.webp';
import gal4 from '../../images/פנטהאוז תל אביבי - הגוש הגדול 1.webp';
import gal5 from '../../images/בית מודרני ואלגנטי בכפר בילו 1.webp';
import gal6 from '../../images/דירת בוטיק - הרצליה הילס 1.webp';

import logoForbes from '../../images/פורבס.webp';
import logoDeMarker from '../../images/דה מרקר.webp';
import logoMako from '../../images/מאקו.webp';
import logoDwell from '../../images/דוול.webp';
import logoArchizer from '../../images/ארקיזר.webp';
import logoWalla from '../../images/וואלה בית ועיצוב.webp';
import logoEt from '../../images/מגזין את.webp';
import logoBinyan from '../../images/בניין ודיור.webp';
import portrait from '../../images/נרקיס תדמיתית.webp';
import waReview from '../../images/whatsapp-review-70k.jpeg';

const pressLogos = [
  { src: logoForbes, alt: 'Forbes', dark: true },
  { src: logoDeMarker, alt: 'דה מרקר' },
  { src: logoMako, alt: 'מאקו', dark: true },
  { src: logoDwell, alt: 'Dwell' },
  { src: logoArchizer, alt: 'Architizer' },
  { src: logoWalla, alt: 'וואלה בית ועיצוב' },
  { src: logoEt, alt: 'מגזין את' },
  { src: logoBinyan, alt: 'בניין ודיור', dark: true },
];

const stats = [
  { num: '70,000 ₪', label: 'נחסכו ללקוח בודד מול הקבלן' },
  { num: '14+', label: 'שנות ליווי וניסיון בעיצוב' },
  { num: 'מאות', label: 'בתים שתוכננו ועוצבו' },
];

const WA = (text) =>
  `https://wa.me/972544998929?text=${encodeURIComponent(text)}`;

const problems = [
  {
    title: 'שינויי דיירים = כסף אחרי חתימה',
    text: 'כל שינוי קטן - הזזת שקע, הוספת נקודת מים, שינוי ריצוף - הופך לחיוב נפרד לאחר שחתמתם. הקבלן לא יזכיר זאת מרצונו.',
  },
  {
    title: 'אין מספרים על מה שמחוץ לחוזה',
    text: 'מטבח, ריהוט, תאורה, וילונות ומכשירי חשמל יכולים להגיע בקלות ל-400,000 ₪ נוספים. כמעט אף אחד לא מכין תקציב לזה מראש.',
  },
  {
    title: 'הזמן לדרוש הוא לפני החתימה',
    text: 'אחרי שחתמתם - הכוח עובר לקבלן. לפני החתימה, עם הכלי הנכון, יש לכם עמדת מיקוח חזקה מאוד.',
  },
  {
    title: 'לא יודעים מה לדרוש',
    text: 'רוב הרוכשים לא מגיעים עם רשימה מסודרת. הקבלן מנוסה. אתם לא. זה הפער שעולה לכם הון.',
  },
];

const tools = [
  {
    title: 'נספח שינויי דיירים לקבלן',
    text: 'מסמך מקצועי מלא עם כל הדרישות שצריך להגיש לקבלן לפני חתימת החוזה - מנוסח, מסודר ומוכן לשימוש.',
  },
  {
    title: 'מחשבון תקציב כולל לדירה',
    text: 'גיליון אקסל אינטראקטיבי - מזינים מספרים ויודעים בדיוק לאן הולך הכסף, עוד לפני שהתחלתם.',
  },
];

const forWho = [
  'רוכשים דירה מקבלן בבנייה',
  'לפני חתימת חוזה המכר',
  'רוצים לדעת כמה הכל עולה באמת',
  'רוצים כוח מיקוח מול הקבלן',
  'מתחילים לתכנן את עיצוב הדירה',
];

const plans = [
  {
    name: 'הנספח',
    price: '297',
    tagline: 'הכלי שמתחיל את המשא ומתן',
    featured: false,
    features: [
      { t: 'נספח שינויי דיירים מלא (Word + PDF)', ok: true },
      { t: 'מוכן להגשה ישירה לקבלן', ok: true },
      { t: 'משלוח מיידי למייל', ok: true },
      { t: 'מחשבון תקציב כולל לדירה', ok: false },
      { t: 'שיחת זום אישית של שעה', ok: false },
    ],
    cta: 'רכישה ב-297 ₪',
    wa: 'היי נרקיס, אני רוצה לרכוש את הנספח ב-297 ₪',
  },
  {
    name: 'החבילה המלאה',
    price: '1,490',
    tagline: 'הליווי שמחזיר את עצמו הכי מהר',
    featured: true,
    features: [
      { t: 'נספח שינויי דיירים מלא (Word + PDF)', ok: true },
      { t: 'מחשבון תקציב כולל לדירה (Excel)', ok: true },
      { t: 'שיחת זום אישית של שעה איתי', ok: true },
      { t: 'התאמת הנספח לדירה שלכם', ok: true },
      { t: 'הדרכה איך להציג את זה לקבלן', ok: true },
    ],
    cta: 'רכישה ב-1,490 ₪',
    wa: 'היי נרקיס, אני רוצה לרכוש את החבילה המלאה ב-1,490 ₪',
  },
];

const gallery = [
  { src: gal2, cap: 'יוקרה במגדל - דירת יוקרה אורבנית', wide: true },
  { src: gal1, cap: 'בית פרטי בשחור ולבן' },
  { src: gal3, cap: 'חלום טוסקני - דופלקס כפרי' },
  { src: gal5, cap: 'בית מודרני ואלגנטי בכפר בילו' },
  { src: gal4, cap: 'פנטהאוז תל אביבי - הגוש הגדול', wide: true },
  { src: gal6, cap: 'דירת בוטיק - הרצליה הילס' },
];

const testimonials = [
  {
    text: 'נרקיס האלופה 💪 בזכות היכולות שלך ליצור קשרי אנוש מצוינים הצלחנו לקבל כל מה שביקשנו מהקבלן.. 70,000 ש״ח!!! זה מטורף. מודים לך מאוד ❤️',
    wide: true,
  },
  {
    text: 'לא האמנו כמה דברים אפשר לפספס לפני חתימה מול קבלן. בזכות הבדיקה והליווי המקצועי הצלחנו לקבל זיכויים והטבות בשווי של כ-70,000 ₪. חסכת לנו הרבה כסף, כאב ראש ובעיקר נתת לנו ביטחון בתהליך. תודה ענקית!',
  },
  {
    text: 'כבר בשלב בדיקת המסמכים לפני החתימה קיבלנו הערות ותיקונים שלא היינו חושבים עליהם לבד. חלק גדול מהסעיפים התקבלו על ידי הקבלן, וזה חסך לנו המון כסף, זמן והתעסקות בהמשך. הליווי היה מקצועי, יסודי ונתן לנו שקט אמיתי.',
  },
  {
    text: 'המעצבת המושלמת! מלווה אותנו למעלה מ-3 שנים מאז שרכשנו דירה על הנייר. היו לי המון חששות, ויצא בית מושלם, יפה, מפנק ונוח. נרקיס היא בן אדם מיוחד, מוכשרת מאוד, רגישה וקשובה. זכינו בה 💖',
  },
];

const faqs = [
  {
    q: 'למה דווקא לפני חתימת החוזה?',
    a: 'לפני חתימת חוזה המכר עם הקבלן זה הזמן הקריטי. ברגע שחתמתם, כוח המיקוח שלכם יורד משמעותית וכל שינוי הופך לתוספת תשלום.',
  },
  {
    q: 'מה אם הקבלן לא יסכים לדרישות?',
    a: 'לא כל קבלן יסכים לכל פריט - וזה בסדר. המסמך נותן לכם מינוף: גם אם הקבלן יסכים ל-50% מהדרישות, אתם חוסכים עשרות אלפי שקלים. לקוחות קיבלו זיכויים של 70,000 ₪ כי הגישו מסמך מסודר ומקצועי.',
  },
  {
    q: 'מה בדיוק אני מקבל אחרי הרכישה?',
    a: 'מיד לאחר הרכישה ישלח לכם מייל עם כל הקבצים: נספח שינויי הדיירים בפורמט Word ו-PDF, ומחשבון התקציב באקסל (בחבילה המלאה).',
  },
  {
    q: 'מה כוללת שיחת הזום?',
    a: 'שיחת זום של שעה איתי אישית - נעבור על הנספח ביחד, נתאים אותו לדירה הספציפית שלכם, ואדריך אתכם איך להציג אותו לקבלן. זו ההשקעה שמחזירה את עצמה הכי מהר.',
  },
  {
    q: 'מתאים גם לדירה יד שנייה?',
    a: 'המסמך נוצר עבור דירות קבלן בבנייה חדשה. אם אתם קונים דירה יד שנייה, חלק מהפריטים פחות רלוונטיים - אך מחשבון התקציב יהיה שימושי לכל סוג דירה.',
  },
];

const Reveal = ({ children, className = '', delay = 0 }) => {
  const ref = useRef(null);
  const [shown, setShown] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(
      ([e]) => {
        if (e.isIntersecting) {
          setShown(true);
          io.unobserve(el);
        }
      },
      { threshold: 0.15 }
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);
  return (
    <div
      ref={ref}
      className={`${styles.reveal} ${shown ? styles.revealIn : ''} ${className}`}
      style={{ transitionDelay: `${delay}ms` }}
    >
      {children}
    </div>
  );
};

const Guide = () => {
  const [activeFaq, setActiveFaq] = useState(null);
  const faqRefs = useRef([]);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <div className={styles.page} dir="rtl">
      {/* ===== HERO ===== */}
      <header className={styles.hero}>
        <div className={styles.heroGlow} />
        <span className={`${styles.decorCorner} ${styles.cornerTR}`} />
        <span className={`${styles.decorCorner} ${styles.cornerBL}`} />

        <div className={styles.heroIntroBand}>
          <p className={styles.heroPressLead}>כפי שהופיעה ב:</p>
          <div className={styles.pressRow}>
            {pressLogos.map((l, i) => (
              <img
                key={i}
                src={l.src}
                alt={l.alt}
                className={
                  l.dark
                    ? `${styles.heroMarqueeLogo} ${styles.heroMarqueeLogoDark}`
                    : styles.heroMarqueeLogo
                }
              />
            ))}
          </div>
          <p className={styles.heroPresents}>נרקיס ברזני מציגה</p>
        </div>

        <div className={styles.heroInner}>
          <div className={styles.heroContent}>
            <p className={styles.heroIntro}>
              קניתם דירה מקבלן? זה מה שהקבלן לא רוצה שתדעו.
            </p>
            <h1 className={styles.heroTitle}>
              איך לחסוך <strong>עשרות אלפי שקלים</strong>
              <br />
              רק מלדעת מה לשאול
              <br />
              ומה להגיד לקבלן
            </h1>
            <p className={styles.heroSub}>
              מדריך פרקטי שאומר לכם בדיוק מה לדרוש מהקבלן, איך לנסח את זה ומתי -
              כדי לצאת מהפגישה עם דירה ששווה הרבה יותר, בלי לשלם על כל שינוי קטן
              אחרי שכבר חתמתם.
            </p>
            <div className={styles.heroBtns}>
              <button
                className={styles.heroCta}
                onClick={() => scrollTo('pricing')}
              >
                אני רוצה את המדריך!
              </button>
            </div>
          </div>

          <div className={styles.heroProof}>
            <div className={styles.waCard}>
              <img
                className={styles.waImg}
                src={waReview}
                alt="הודעת וואטסאפ מלקוחה: נחסכו 70,000 ₪ מול הקבלן"
                loading="eager"
              />
            </div>
            <p className={styles.waTag}>
              הודעה אמיתית מלקוחה · נחסכו 70,000 ₪
            </p>
          </div>
        </div>
      </header>

      {/* ===== PROBLEM ===== */}
      <section className={`${styles.section} ${styles.cream}`}>
        <div className={styles.container}>
          <Reveal>
            <p className={styles.problemLead}>
              אם קניתם דירה מקבלן - חשוב לי שתדעו:
            </p>
            <h2 className={styles.sectionTitle}>מחיר הדירה הוא רק ההתחלה</h2>
            <p className={styles.sectionSub}>
              ארבעה דברים שכמעט כל רוכש מגלה מאוחר מדי - וכמה כסף הם עולים.
            </p>
          </Reveal>
          <div className={styles.problemList}>
            {problems.map((p, i) => (
              <Reveal key={i} delay={i * 90}>
                <div className={styles.problemRow}>
                  <span className={styles.problemNum}>
                    {String(i + 1).padStart(2, '0')}
                  </span>
                  <div className={styles.problemBody}>
                    <h3 className={styles.problemRowTitle}>{p.title}</h3>
                    <p className={styles.problemRowText}>{p.text}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* ===== STORY / PROOF ===== */}
      <section className={`${styles.section} ${styles.dark}`}>
        <div className={styles.container}>
          <Reveal className={styles.storyWrap}>
            <div className={styles.storyAmount}>70,000 ₪</div>
            <h2 className={styles.storyTitle}>
              כשהגשנו את המסמך לקבלן - הוא הסכים
            </h2>
            <p className={styles.storyText}>
              לקוחות שהגיעו לקבלן עם נספח מסודר ומקצועי קיבלו זיכויים והטבות
              בשווי של עשרות אלפי שקלים. אותו מסמך - לפני החתימה - הוא ההבדל
              בין לבקש בעל פה לבין לדרוש בכתב, ממקום של כוח.
            </p>
          </Reveal>
        </div>
      </section>

      {/* ===== TOOLS ===== */}
      <section className={`${styles.section} ${styles.creamSoft}`}>
        <div className={styles.container}>
          <Reveal>
            <h2 className={styles.sectionTitle}>שני כלים שישנו את המשא ומתן</h2>
            <p className={styles.sectionSub}>
              כל מה שצריך כדי להגיע מוכנים, מסודרים, ועם יד על העליונה.
            </p>
          </Reveal>
          <div className={styles.toolsGrid}>
            {tools.map((tool, i) => (
              <Reveal key={i} delay={i * 100}>
                <div className={styles.toolCard}>
                  <span className={styles.cardNum}>
                    {String(i + 1).padStart(2, '0')}
                  </span>
                  <h3 className={styles.cardTitle}>{tool.title}</h3>
                  <p className={styles.cardText}>{tool.text}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* ===== FOUNDER ===== */}
      <section className={`${styles.section} ${styles.cream}`}>
        <div className={styles.container}>
          <div className={styles.founder}>
            <Reveal className={styles.founderImgWrap}>
              <img src={portrait} alt="נרקיס רובין ברזני" className={styles.founderImg} />
            </Reveal>
            <Reveal className={styles.founderText} delay={120}>
              <span className={styles.founderHairline} />
              <h2 className={styles.founderTitle}>נעים להכיר, נרקיס</h2>
              <p className={styles.founderBio}>
                אני נרקיס רובין ברזני, מעצבת פנים כבר למעלה מ-14 שנה. ליוויתי
                מאות משפחות מרגע קבלת המפתח - ולא מעט פעמים הרבה לפני, כבר מול
                הקבלן. את כל מה שלמדתי בדרך הקשה זיקקתי לכלים הפשוטים שבחבילה
                הזו, כדי שתיכנסו לתהליך מתוך ידע, ביטחון וכוח.
              </p>
              <p className={styles.founderSign}>נרקיס רובין ברזני · סטודיו בוטיק לעיצוב פנים</p>
            </Reveal>
          </div>
        </div>
      </section>

      {/* ===== PRICING ===== */}
      <section id="pricing" className={`${styles.section} ${styles.creamSoft}`}>
        <div className={styles.container}>
          <Reveal>
            <h2 className={styles.sectionTitle}>בחרו את החבילה שלכם</h2>
            <p className={styles.sectionSub}>
              קובץ דיגיטלי · משלוח מיידי למייל · ההשקעה מחזירה את עצמה כבר
              מהזיכוי הראשון.
            </p>
          </Reveal>
          <Reveal>
            <div className={styles.pricingGrid}>
              {plans.map((plan, i) => (
                <div
                  key={i}
                  className={`${styles.plan} ${
                    plan.featured ? styles.planFeatured : ''
                  }`}
                >
                  {plan.featured && (
                    <span className={styles.planBadge}>הכי משתלם</span>
                  )}
                  <div className={styles.planPrice}>
                    <span className={styles.planCurrency}>₪</span>
                    {plan.price}
                  </div>
                  <div className={styles.planName}>{plan.name}</div>
                  <p className={styles.planTagline}>{plan.tagline}</p>
                  <ul className={styles.planFeatures}>
                    {plan.features.map((f, j) => (
                      <li
                        key={j}
                        className={f.ok ? styles.feOk : styles.feNo}
                      >
                        {f.t}
                      </li>
                    ))}
                  </ul>
                  <a
                    className={
                      plan.featured ? styles.btnGoldFull : styles.btnGhostFull
                    }
                    href={WA(plan.wa)}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {plan.cta}
                  </a>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </section>

      {/* ===== FOR WHO ===== */}
      <section className={`${styles.section} ${styles.cream}`}>
        <div className={styles.container}>
          <Reveal>
            <h2 className={styles.sectionTitle}>אם אחד מאלה נשמע מוכר</h2>
            <p className={styles.sectionSub}>
              החבילה נבנתה בדיוק בשבילכם.
            </p>
          </Reveal>
          <div className={styles.whoGrid}>
            {forWho.map((w, i) => (
              <Reveal key={i} delay={i * 60}>
                <div className={styles.whoCard}>{w}</div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* ===== GALLERY ===== */}
      <section className={`${styles.section} ${styles.cream}`}>
        <div className={styles.containerWide}>
          <Reveal>
            <h2 className={styles.sectionTitle}>כך נראה הסוף</h2>
            <p className={styles.sectionSub}>
              פרויקטים שעברו ליווי מלא - מהנספח לקבלן ועד המפתח ביד.
            </p>
          </Reveal>
          <div className={styles.galleryGrid}>
            {gallery.map((g, i) => (
              <Reveal key={i} delay={i * 70}>
                <figure className={styles.galCard}>
                  <div className={styles.galMedia}>
                    <img src={g.src} alt={g.cap} loading="lazy" />
                  </div>
                  <figcaption className={styles.galCaption}>
                    <span className={styles.galCapText}>{g.cap}</span>
                  </figcaption>
                </figure>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* ===== TESTIMONIALS ===== */}
      <section className={`${styles.section} ${styles.creamSoft}`}>
        <div className={styles.container}>
          <Reveal>
            <h2 className={styles.sectionTitle}>מה אומרים עליי</h2>
          </Reveal>
          <div className={styles.testiGrid}>
            {testimonials.map((t, i) => (
              <Reveal
                key={i}
                delay={i * 80}
                className={t.wide ? styles.testiWide : ''}
              >
                <div className={styles.testiCard}>
                  <span className={styles.testiMark}>”</span>
                  <p className={styles.testiText}>{t.text}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* ===== FAQ ===== */}
      <section className={`${styles.section} ${styles.cream}`}>
        <div className={styles.containerNarrow}>
          <Reveal>
            <h2 className={styles.sectionTitle}>כל מה שרציתם לשאול</h2>
          </Reveal>
          <div className={styles.faqList}>
            {faqs.map((item, i) => (
              <div
                key={i}
                className={`${styles.faqItem} ${
                  activeFaq === i ? styles.faqActive : ''
                }`}
              >
                <button
                  className={styles.faqQuestion}
                  onClick={() => setActiveFaq(activeFaq === i ? null : i)}
                  aria-expanded={activeFaq === i}
                >
                  <span className={styles.faqQText}>{item.q}</span>
                  <span className={styles.faqIcon}>
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M12 5v14M5 12h14" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </span>
                </button>
                <div
                  className={styles.faqAnswer}
                  ref={(el) => (faqRefs.current[i] = el)}
                  style={{
                    maxHeight:
                      activeFaq === i
                        ? `${faqRefs.current[i]?.scrollHeight + 40}px`
                        : '0px',
                  }}
                >
                  <p className={styles.faqAText}>{item.a}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ===== FINAL CTA ===== */}
      <section className={`${styles.section} ${styles.dark} ${styles.finalCta}`}>
        <div className={styles.heroGlow} />
        <div className={styles.container}>
          <Reveal className={styles.finalInner}>
            <h2 className={styles.finalTitle}>מוכנים לחסוך?</h2>
            <p className={styles.finalText}>
              השקעה של 297 ₪ שיכולה להחזיר לכם עשרות אלפי שקלים - לפני
              שתחתמו שורה אחת.
            </p>
            <div className={styles.heroBtns}>
              <button className={styles.btnGold} onClick={() => scrollTo('pricing')}>
                לבחירת חבילה
              </button>
              <a
                className={styles.btnGhost}
                href={WA('היי נרקיס, יש לי שאלה לגבי חבילת הדירה החכמה')}
                target="_blank"
                rel="noopener noreferrer"
              >
                יש לי שאלה
              </a>
            </div>
          </Reveal>
        </div>
      </section>

      {/* ===== FOOTER ===== */}
      <footer className={styles.footer}>
        © 2010 נרקיס רובין ברזני · סטודיו בוטיק לעיצוב פנים · כל הזכויות שמורות
      </footer>
    </div>
  );
};

export default Guide;
